import styled from "styled-components";

export const ActionsContainer = styled.div`
  height: 46;
  display: flex;
  align-items: center;

  button:first-child {
    margin-right: 12px;
  }

  .form-container {
    height: 32px;
  }

  .search-obra-input {
    z-index: 99999;
    margin-right: 12px;
  }

  .buttonObra {
    width: 46px;
    height: 46px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
